function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import oaFromBox from '@/components/common/oaFromBox';
import SettingMer from '@/libs/settingMer';
import helper from '@/libs/helper';
import { getToken } from '@/utils/auth';
import 'animate.css';
import importExcel from '@/components/common/importExcel';
import ExportExcel from '@/components/common/exportExcel';
import { attendanceGroupSelectApi } from '@/api/config';
import { attendanceImport, attendanceImportFile } from '@/api/enterprise';
export default {
  name: 'CrmebOaEntFormBox',
  components: {
    importExcel: importExcel,
    oaFromBox: oaFromBox,
    ExportExcel: ExportExcel
  },
  props: ['type', 'total'],
  data: function data() {
    return {
      title: '',
      uploadData: {},
      where: {},
      fileList: [],
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      dropdownList: [{
        label: '导入',
        value: 1
      }, {
        label: '导出',
        value: 2
      }, {
        label: '导出模板',
        value: 3
      }, {
        label: '企微导入',
        value: 4
      }, {
        label: '钉钉导入',
        value: 5
      }],
      list: [],
      exportData: {
        data: [],
        cols: [{
          wpx: 130
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 120
        }, {
          wpx: 130
        }, {
          wpx: 130
        }]
      },
      salesmanList: [{
        value: 1,
        name: '正常'
      }, {
        value: 2,
        name: '迟到'
      }, {
        value: 3,
        name: '严重迟到'
      }, {
        value: 4,
        name: '早退'
      }, {
        value: 5,
        name: '缺卡'
      }, {
        value: 6,
        name: '地点异常'
      }],
      search: [],
      timeValue: [],
      viewSearch: [],
      pickerOptions: this.$pickerOptionsTimeEle,
      saveName: '',
      importType: 1
    };
  },
  computed: {
    fileUrl: function fileUrl() {
      return SettingMer.https + "/client/import";
    }
  },
  mounted: function mounted() {
    if (this.type !== 'month') {
      this.timeValue = [this.$moment(new Date()).format('YYYY/MM/DD'), this.$moment(new Date()).format('YYYY/MM/DD')];
      this.where.time = this.timeValue[0] + '-' + this.timeValue[1];
    } else {
      this.timeValue = this.$moment(new Date()).format('YYYY-MM');
      this.where.time = this.timeValue;
    }
    this.getList();
    this.$emit('confirmData', this.where);
  },
  methods: {
    dropdownFn: function dropdownFn(data) {
      if (data.value === 1) {
        this.importType = 1;
        this.$refs.importExcel.btnClick();
      } else if (data.value === 2) {
        this.exportExcelData();
      } else if (data.value === 3) {
        this.exportTemplate();
      } else if (data.value === 4) {
        this.importType = 4;
        this.$refs.importExcel.btnClick();
      } else if (data.value === 5) {
        this.importType = 5;
        this.$refs.importExcel.btnClick();
      }
    },
    getSearch: function getSearch(type) {
      this.viewSearch = [{
        field: 'group_id',
        title: '考勤组',
        type: 'select',
        options: this.list
      }, {
        field: 'scope',
        title: '数据',
        type: 'select',
        options: [{
          name: '包含离职人员',
          value: ''
        }, {
          name: '不包含离职人员',
          value: '1'
        }, {
          name: '仅展示离职人员',
          value: '2'
        }]
      }, {
        field: 'user_id',
        title: '人员',
        type: 'user_id',
        options: []
      }];
      var searchList = [{
        field_name: '考勤时间',
        field_name_en: 'time',
        form_value: 'date_picker'
      }, {
        field_name: '打卡结果',
        field_name_en: 'status',
        form_value: 'select',
        data_dict: this.salesmanList
      }, {
        field_name: '部门',
        field_name_en: 'frame_id',
        form_value: 'frame_id',
        data_dict: []
      }];
      if (type == 'clock') {
        this.title = '打卡记录';
        var obj = {
          field_name_en: 'group_id',
          field_name: '考勤组',
          form_value: 'select',
          data_dict: this.list
        };
        searchList.splice(1, 1);
        this.search = searchList;
        this.search.push(obj);
        this.viewSearch.splice(0, 1);
      } else if (type == 'month') {
        this.title = '月度统计';
        searchList[0].form_value = 'month';
        this.search = searchList;
      } else {
        this.title = '每日统计';
        this.search = searchList;
      }
    },
    // 获取考勤组数据
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return attendanceGroupSelectApi();
            case 2:
              result = _context.sent;
              _this.list = result.data;
              _this.list.forEach(function (item) {
                item.value = item.id;
              });
              _this.getSearch(_this.type);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
    },
    // 上传前
    handleUpload: function handleUpload(file) {
      var types = helper.uploadCustomerTypes;
      var fileTypeName = file.name.substr(file.name.lastIndexOf('.') + 1);
      var isImage = types.includes(fileTypeName);
      if (!isImage) {
        this.$message.error('不支持该' + fileTypeName + '格式');
        return false;
      }
      return true;
    },
    // 上传成功
    handleSuccess: function handleSuccess(response) {
      if (response.status === 200) {
        this.$message.success(response.message);
        this.$emit('confirmData', this.where);
      } else {
        this.$message.error(response.message);
        this.$emit('confirmData', this.where);
      }
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.reset();
      } else {
        this.where = _objectSpread(_objectSpread({}, this.where), data);
        this.$emit('confirmData', this.where);
      }
    },
    reset: function reset() {
      this.where = {};
      if (this.type == 'month') {}
      this.departmentList = [];
      this.$emit('confirmData', this.where);
    },
    // 导出报表
    exportExcelData: function exportExcelData() {
      this.$emit('confirmData', this.where, '导出');
    },
    //导入打卡记录
    importExcelData: function importExcelData(arrRes) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this2.importType === 4)) {
                _context2.next = 7;
                break;
              }
              arrRes.splice(0, 2);
              arrRes.splice(1, 1);
              _context2.next = 5;
              return attendanceImportFile({
                type: 2,
                data: _this2.formatData(arrRes)
              });
            case 5:
              _context2.next = 15;
              break;
            case 7:
              if (!(_this2.importType === 5)) {
                _context2.next = 13;
                break;
              }
              arrRes.splice(0, 2);
              _context2.next = 11;
              return attendanceImportFile({
                type: 1,
                data: _this2.formatData(arrRes)
              });
            case 11:
              _context2.next = 15;
              break;
            case 13:
              _context2.next = 15;
              return attendanceImport(_this2.formatData(arrRes));
            case 15:
              _this2.$emit('confirmData', _this2.where);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //格式化打卡记录
    formatData: function formatData(data) {
      var thead = data[0];
      var result = [];
      data.splice(0, 1);
      for (var i = 0; i < data.length; i++) {
        result.push({});
        for (var j = 0; j < data[i].length; j++) {
          if (thead[j]) result[i][thead[j]] = data[i][j] === '--' ? '' : data[i][j];
        }
      }
      return result;
    },
    // 导出模版
    exportTemplate: function exportTemplate() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.saveName = '打卡记录模板(' + _this3.$moment(new Date()).format('MMDDHHmmss') + ').xlsx';
              _this3.exportData.data = [['时间', '姓名', '第一次上班', '第一次下班', '第二次上班', '第二次下班'], ['2024/06/20 星期三', '张三', '2024/06/12 06:30', '2024/06/12 18:30', '2024/06/12 06:30', '2024/06/12 18:30']];
              _this3.$nextTick(function () {
                _this3.$refs.exportExcel.exportExcel();
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};